import { useContext } from "react";
import { Text } from "@mantine/core";
import { useCreateSession } from "../../api/session";
import { useGetSponsors } from "../../api/sponsors";
import { AuthContext } from "../../services/context";
import {
  getCurrentWorkspace,
  isCurrentEventAdmin,
} from "../../services/userConfig";
import {
  useGetPeopleTagsBySubtype,
  useGetSessionTagsByEventId,
} from "../../api/tag";
import { useGetAllSpeakers } from "../../api/speakers";
import { useGetEvent, useGetEventLocations } from "../../api/event";
import SessionForm from "./Form";
import { notifications } from "@mantine/notifications";

export default function CreateSession() {
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);

  const { data: event } = useGetEvent(currentWorkspace.eventId);

  const { data: speakers } = useGetAllSpeakers({
    eventId: currentWorkspace.eventId,
    limit: 1000,
  });

  const speakersOptions = speakers?.data?.map((speaker) => ({
    label: `${speaker.firstName} ${speaker.lastName}, ${speaker.occupation}`,
    value: speaker.id.toString(),
  }));

  const {
    data: sponsors,
    isSuccess: sponsorsSuccess,
    isError: sponsorsIsError,
    error: sponsorsError,
  } = useGetSponsors({
    eventId: currentWorkspace.eventId,
  });

  const { data: locations } = useGetEventLocations(currentWorkspace.eventId);

  const locationsOptions = locations?.map((location) => ({
    label: location.name,
    value: location.id.toString(),
  }));

  const { mutate, isPending } = useCreateSession();

  let sponsorsOptions;
  if (sponsorsSuccess) {
    sponsorsOptions = sponsors.data.map((s) => ({
      label: s.name,
      value: s.id.toString(),
    }));
  }

  const { data: sessionTags } = useGetSessionTagsByEventId(
    currentWorkspace.eventId
  );

  const { data: categoryTags } = useGetPeopleTagsBySubtype({
    subtype: "categoryOfUser",
    eventId: currentWorkspace.eventId,
  });

  const enableActions = isCurrentEventAdmin(user);

  const onSubmit = (data, { onSuccess }) => {
    data.eventId = currentWorkspace.eventId;
    mutate(data, {
      onSuccess: (response) => {
        if (response.warning) {
          notifications.show({
            title: "Duplicate session(s) found",
            message: `Found ${response.warning.duplicates.length} session${response.warning.duplicates.length > 1 ? "s" : ""} that have the same title and starting time as the one you created.`,
            color: "yellow",
            autoClose: 10000,
            withCloseButton: true,
          });
        }

        onSuccess();
      },
    });
  };

  if (sponsorsIsError) {
    return <Text>Error while getting sponsors data: {sponsorsError}</Text>;
  }

  return (
    <SessionForm
      mode="create"
      enableActions={enableActions}
      speakerOptions={speakersOptions}
      sponsorOptions={sponsorsOptions}
      tagOptions={sessionTags}
      categoryTagOptions={categoryTags}
      locationsOptions={locationsOptions}
      event={event}
      onSubmit={onSubmit}
      isLoading={isPending}
    />
  );
}
